import { render, staticRenderFns } from "./LicitacaoFornecedorAcoesProtocolos.vue?vue&type=template&id=1a98a8c9&scoped=true"
import script from "./LicitacaoFornecedorAcoesProtocolos.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorAcoesProtocolos.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorAcoesProtocolos.vue?vue&type=style&index=0&id=1a98a8c9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98a8c9",
  null
  
)

export default component.exports